import { GridItem, LayoutGrid, TypographyV3 } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

import Motion from '@/app/components/Motion';

const WhyOuraResearch = (): JSX.Element => {
  const t = useTranslations();

  return (
    <section className="relative py-16" data-cy="why-oura-research">
      <LayoutGrid>
        <GridItem
          className="pb-16 lg:px-4 lg:pb-32"
          colEnd={{ sm: 'main', md: 21, lg: 20 }}
          colStart={{ sm: 'main', md: 5, lg: 6 }}
        >
          <Motion
            initial={{ filter: 'blur(10px)' }}
            whileInView={{ filter: 'blur(0px)', transition: { duration: 1 } }}
            viewport={{ once: true }}
          >
            <TypographyV3
              Element="h3"
              variant="h1"
              align="center"
              height="tight"
            >
              {t.rich('research_title')}
            </TypographyV3>
          </Motion>
        </GridItem>
        <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 'main' }}>
          <div className="flex flex-wrap divide-y divide-sandstone-500 lg:divide-x lg:divide-y-0">
            <div className="flex w-full flex-col items-center py-10 lg:w-1/3 lg:px-4 lg:py-0">
              <TypographyV3
                className="mb-5 text-5xl"
                font="serif"
                variant="h3"
                align="center"
              >
                {t('20_phd_heading')}
              </TypographyV3>
              <TypographyV3 className="w-10/12 text-center">
                {t('20_phd_copy')}
              </TypographyV3>
            </div>
            <div className="flex w-full flex-col items-center py-10 lg:w-1/3 lg:px-4 lg:py-0">
              <TypographyV3
                className="mb-5 text-5xl"
                font="serif"
                variant="h3"
                align="center"
              >
                {t('4_gen_heading')}
              </TypographyV3>
              <TypographyV3 className="w-10/12 text-center">
                {t('3_gen_copy')}
              </TypographyV3>
            </div>
            <div className="flex w-full flex-col items-center pt-10 lg:w-1/3 lg:px-4 lg:py-0">
              <TypographyV3
                className="mb-5 text-5xl"
                font="serif"
                variant="h3"
                align="center"
              >
                {t('members_heading')}
              </TypographyV3>
              <TypographyV3 className="w-10/12 text-center">
                {t('members_copy')}
              </TypographyV3>
            </div>
          </div>
        </GridItem>
      </LayoutGrid>
    </section>
  );
};

export default WhyOuraResearch;
